export function scrollTo(id) {
  window.scrollTo(0, document.getElementById(id).offsetTop);
}
